export const modifyRules = {
  name: [
    { required: true, message: '请输入角色名称', trigger: 'blur' }
  ]
}

export const addRules = {
  name: [
    { required: true, message: '请输入角色名称', trigger: 'blur' }
  ]
}
